import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { SocketProvider } from '../context/socketContext';

const isAuthenticated = () => {
	return Cookies.get('authToken') || localStorage.getItem('authToken');
};

const PrivateRoute = ({ element, ...rest }) => {
	return isAuthenticated() ? (
		<SocketProvider> {React.cloneElement(element, { ...rest })} </SocketProvider>
	) : (
		<Navigate to="/" />
	);
};

export default PrivateRoute;
